import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';

import { allowEditingAction, cancelOrderAction, confirmRefundAction, markAsCommissionedAction, markAsDeliveredAction, releaseOrderAction, updateOrderStatusAction } from '../../../redux/actions/orderActions';
import HoverFullText from '../../../elements/HoverToolKit';

const SingleOrderButtons = ({ order, user, hideViewButton }) => {






    const dispatch = useDispatch();
    const { message } = useSelector(state => state.order)


    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState('');

    const [popupHeading, setpopupHeading] = useState('');
    const [popupPara, setpopupPara] = useState('');







    const handleShowPopup = (status) => {


        setShowPopup(true);
        setActionToPerform(status);


        if (status === "DELIVERED") {
            setpopupHeading("Mark as Delivered");
            setpopupPara("Are you sure you want to mark this order as delivered?");
        }
        if (status === "ALLOW_EDITING") {
            setpopupHeading("Allow Editing");
            setpopupPara("Are you sure you want to allow editing for this order?");
        }
        if (status === "CONFIRM_REFUND") {
            setpopupHeading("Refund Acknowledgment Confirmation");
            setpopupPara(`
                By confirming this acknowledgment, you declare that you have received the full refund for this product (Expected Amount in USD: ${order?.product_price}).

                Once confirmed, you will not be able to submit any complaints, disputes, or reports related to refund issues for this order.

                Please ensure the refunded amount has been fully received before proceeding.`);
        }
        if (status === "CANCELLED") {
            setpopupHeading("Cancel Order");
            setpopupPara(`Are you sure you want to cancel this order?`);
        }
        if (status === "RELEASE_HOLD") {
            setpopupHeading("Release from Hold");
            setpopupPara(`Are you sure you want to release this order from hold?`);
        }
        if (status === "REVIEWED") {
            setpopupHeading("Mark as Reviewed");
            setpopupPara(`Are you sure you want to move this order to Reviewed status?`);
        }
        if (status === "ORDERED") {
            setpopupHeading("Move to Ordered");
            setpopupPara(`Are you sure you want to move this order back to Ordered status?`);
        }

    }



    const handleMarkAsCommissioned = () => {

        

            setShowPopup(true);
            setActionToPerform("COMMISSIONED")
            setpopupHeading("Mark as Commissioned")
            setpopupPara(`
                By marking this order as Commissioned, you confirm that the order has been successfully completed and the commission can be processed. Please ensure all necessary steps have been taken and the order is ready for commissioning before proceeding.`)


    }




    const handleDispatch = () => {


        if (!actionToPerform) return toast.error("Please select an action to Perform");



        if (actionToPerform === "DELIVERED") {
            dispatch(markAsDeliveredAction({ order_id: order?.id }));
        }
        if (actionToPerform === "ALLOW_EDITING") {
            dispatch(allowEditingAction({ order_id: order?.id }));
        }
        if (actionToPerform === "HidePopup") {
            setShowPopup(false)
        }


        if (actionToPerform === "CONFIRM_REFUND") {
            dispatch(confirmRefundAction({ order_id: order?.id }))
        }

        if (actionToPerform === "COMMISSIONED") {
            dispatch(markAsCommissionedAction({ order_id: order?.id }))
        }
        if (actionToPerform === "CANCELLED") {
            dispatch(cancelOrderAction({ order_id: order?.id }))
        }


        if (actionToPerform === "RELEASE_HOLD") {
            dispatch(releaseOrderAction({ order_id: order?.id }))
        }

        if (actionToPerform === "REVIEWED") {
            dispatch(updateOrderStatusAction({ order_id: order?.id, status: "REVIEWED" }))
        }
        if (actionToPerform === "ORDERED") {
            dispatch(updateOrderStatusAction({ order_id: order?.id, status: "ORDERED" }))
        }

    }





    useEffect(() => {
        if (message) {
            setShowPopup(false);
            setActionToPerform('');
        }
    }, [message])

    return (
        <Fragment>
            {(
                (order?.status !== "CANCELLED" &&
                order?.status !== "SYSTEM_CANCELLED" &&
                order?.status !== "SUSPENDED") || (user?.role === "ADMIN" || user?.role === "SUPER_ADMIN" || user?.role === "PMM")) &&
                <div className={`flex  w-[300%] lg:w-[110%] ${order?.status === "ON_HOLD" ? "justify-between" : "justify-end"}  `}>
                    {order?.status === "ON_HOLD" &&
                        <div className="w-[40%] text-[1.5vmax] lg:text-[1vmax] font-3 font-[500] p-[0.5vmax_1vmax]">
                            <span className='text-red-500 flex' >
                                <i className="fa-solid fa-triangle-exclamation"></i> &nbsp;&nbsp;
                                <HoverFullText text={order?.hold_reason} sliceLength={40} />

                            </span>
                        </div>

                    }
                    <div className="flex-center w-fit text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax] flex-center gap-[0.5vmax] bg-slate-50 py-[1vmax] px-[2vmax] rounded-b-2xl mt-[-0.2vmax]" >
                        {!hideViewButton &&
                            <Link
                                to={`/orders/order-details?order_id=${order?.id}`}
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-2)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize 
                           `}
                            >
                                view
                            </Link>
                        }
                        <Link
                            to={`/orders/remarks-on-order?order_id=${order?.id}`}
                            className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize 
                           `}
                        >
                            Add Remarks
                        </Link>
                        {user?.role === "PM" && order?.status === "ORDERED" &&
                            <Link
                                to={`/orders/review-order?order_id=${order?.id}`}
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-5)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize 
                           `}
                            >
                                Mark as Reviewed
                            </Link>
                        }
                        {user?.role === "PM" && (order?.status === "REVIEWED" || order?.status === "ON_HOLD") && order?.is_locked === 0 &&
                            <Link
                                to={`/orders/edit_order?order_id=${order?.id}`}
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-5)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize 
                           `}
                            >
                                <i className="fa-solid fa-pen"></i> &nbsp;&nbsp;
                                edit Order
                            </Link>
                        }
                        {(user?.role === "PMM" || user?.role === "PM") && (
                            <Link
                                to={`/orders/report-order?order_id=${order?.id}`}
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-4)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize 
                           `}
                            >
                                Report
                            </Link>
                        )
                        }

                        {user?.role !== "PM" && (order?.status === "ORDERED" || order?.status === "DELIVERED" || order?.status === "REFUNDED") &&
                            <button
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-5)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize`}
                                onClick={() => handleShowPopup("REVIEWED")}
                            >
                                Mark as Reviewed
                            </button>
                        }
                        {user?.role !== "PM" && (order?.status === "REVIEWED" || order?.status === "ORDERED" || order?.status === "REFUNDED") &&
                            <button
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-5)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize`}
                                onClick={() => handleShowPopup("DELIVERED")}
                            >
                                Mark as Delivered
                            </button>
                        }
                        {user?.role !== "PM" && (order?.status !== "ORDERED") &&
                            <button
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-gray-600 rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize`}
                                onClick={() => handleShowPopup("ORDERED")}
                            >
                                Move to Ordered
                            </button>
                        }
                        {user?.role !== "PM" && (order?.status !== "COMMISSIONED" || order?.status !== "COMPLETED" || order?.status !== "CANCELLED" || order?.status !== "REFUNDED") && order?.is_locked === 1 &&
                            <button
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-6)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize`}
                                onClick={() => handleShowPopup("ALLOW_EDITING")}
                            >
                                Allow Editing
                            </button>
                        }


                        {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN" || user?.role === "PMM" || (order?.status !== "ON_HOLD" && order?.status !== "CANCELLED")) && user?.role !== "PM" &&
                            <Link
                                to={`/orders/on-hold?order_id=${order?.id}`}
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-orange)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize text-center 
                            `}
                            >
                                On Hold
                            </Link>
                        }
                        {user?.role !== "PM" && (order?.status === "REVIEWED" || order?.status === "DELIVERED" || order?.status === "REFUNDED" || order?.status === "ORDERED") &&
                            <Link to={`/orders/review-deleted?order_id=${order?.id}`}
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center  bg-[image:var(--gradient-4)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize text-center`}
                            >
                                Review Deleted
                            </Link>
                        }
                        {
                            user?.role === "PM" && order?.status === "REFUNDED" && order?.refund_confirmed === 0 &&
                            <button
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center  bg-[image:var(--gradient-5)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize text-center`}
                                onClick={() => handleShowPopup("CONFIRM_REFUND")}
                            >
                                acknowledge Refund
                            </button>
                        }
                        {
                            user?.role !== "PM" && order?.status === "ON_HOLD" &&
                            <button
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center  bg-[image:var(--gradient-5)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize text-center`}
                                onClick={() => handleShowPopup("RELEASE_HOLD")}
                            >
                                Release from Hold
                            </button>
                        }

                        {user?.role !== "PM" && (order?.status === "DELIVERED" || order?.status === "REVIEW_DELETED" || order?.status === "REVIEWED" || order?.status === "ORDERED") && !order?.refund_image_proof_url &&
                            <Link
                                to={`/orders/order-refunded?order_id=${order?.id}`}
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-3)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize 
                            `}
                            >
                                {order?.status === "REVIEW_DELETED" ? "Add Refund Details " : "Mark as Refunded"}
                            </Link>
                        }
                        {user?.role !== "PM" && (order?.status === "REFUNDED" || order?.status === "DELIVERED" || order?.status === "REVIEWED") &&
                            <button
                                className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-gray)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize`}
                                onClick={() => handleMarkAsCommissioned()}
                            >
                                Mark as Commissioned
                            </button>
                        }



                        {user?.role !== "PM" && order?.status !== "CANCELLED"
                            &&
                            <button className={`px-[0.6vmax] h-[2.4vmax] flex-center  bg-[image:var(--gradient-4)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax]`}
                                onClick={() => handleShowPopup("CANCELLED")}
                            >Cancel</button>

                        }
                    </div>
                </div>
            }
            {(
                order?.status === "CANCELLED" ||
                order?.status === "SYSTEM_CANCELLED" ||
                order?.status === "SUSPENDED") && !hideViewButton &&
                <div className="flex justify-end  w-[300%] lg:w-full  ">
                    <div className="flex-center w-fit text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax] flex-center gap-[0.5vmax] bg-slate-50 py-[1vmax] px-[2vmax] rounded-b-2xl mt-[-0.2vmax]" >
                        <Link
                            to={`/orders/order-details?order_id=${order?.id}`}
                            className={`px-[0.6vmax] h-[2.4vmax] flex-center bg-[image:var(--gradient-2)] rounded-lg hover:scale-[0.9] text-white text-[1.5vmax] lg:text-[0.9vmax] capitalize 
                           `}
                        >
                            view
                        </Link>
                    </div>
                </div>

            }

            {showPopup &&
                <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-zinc-900/60 backdrop-blur-sm p-4">
                    {/* Close Button on Overlay */}
                    <button 
                        className="fixed top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
                        onClick={() => setShowPopup(false)}
                    >
                        <i className="fa-solid fa-xmark text-lg"></i>
                    </button>

                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden border border-zinc-100">
                        {/* Content */}
                        <div className="p-6 flex flex-col items-center text-center gap-4">
                            <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center text-sky-500">
                                <i className="fa-solid fa-circle-question text-2xl"></i>
                            </div>
                            <div className="flex flex-col gap-2">
                                <h2 className="text-xl font-bold text-zinc-900">{popupHeading}</h2>
                                <p className="text-sm text-zinc-500 whitespace-pre-line leading-relaxed">
                                    {popupPara}
                                </p>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="flex justify-center gap-3 p-6 bg-zinc-50 border-t border-zinc-100">
                            {actionToPerform !== "HidePopup" && (
                                <button 
                                    className="flex-1 px-4 py-2.5 bg-white border border-zinc-200 text-zinc-600 hover:text-zinc-700 font-bold text-sm rounded-xl hover:bg-zinc-50 transition-colors shadow-sm"
                                    onClick={() => {
                                        setShowPopup(false)
                                        setActionToPerform("")
                                    }}
                                >
                                    No
                                </button>
                            )}

                            <button 
                                className={`flex-1 px-4 py-2.5 bg-gradient-to-br from-sky-500 to-indigo-600 text-white font-bold text-sm rounded-xl hover:shadow-md transition-all shadow-sm ${actionToPerform === "HidePopup" ? "max-w-[120px]" : ""}`}
                                onClick={handleDispatch}
                            >
                                {actionToPerform === "HidePopup" ? "Close" : 
                                 actionToPerform === "CONFIRM_REFUND" ? "I Acknowledge" :
                                 actionToPerform === "COMMISSIONED" ? "Mark as Commissioned" : "Yes"}
                            </button>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    )
}

export default SingleOrderButtons